import React from "react";

export default function CorrenctIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#11A75C" />
      <path
        d="M14.125 7.375L8.875 12.625L6.25 10"
        stroke="white"
        stroke-width="1.53"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
